<template>
  <!-- 消息引导 -->
  <div v-if="showGuide" class="message-guide" @touchmove.prevent>
    <img
      class="icon"
      src="https://img01.yzcdn.cn/upload_files/2021/07/16/FpsbqmhDXp8g9tDaUfzTmuC1bkAq.png"
      alt=""
    />
    <img
      class="arrow"
      src="https://img01.yzcdn.cn/upload_files/2021/07/16/FqiqHqf9kHm6FfU8P6HeHTXZ5B9m.png"
    />
    <img
      class="text"
      src="https://img01.yzcdn.cn/upload_files/2021/07/20/FiyKw99h_ID91R8n-BqfPOFTa9IH.png"
      alt=""
    />
    <img
      class="button"
      src="https://img01.yzcdn.cn/upload_files/2021/07/16/Flq108N66b6XPuTOmdWCQiv_DPb0.png"
      @click="noGuide"
    />
  </div>
</template>

<script>
import { register } from '@/plugin/popup'
import { mapState } from 'vuex'
import { updateTreasureBox } from '@/api/user'
export default {
  data() {
    return {
      popupName: 'messageGuid',
      keyName: 'MessageGuide',
      showGuide: false // 是否展示
    }
  },
  computed: {
    ...mapState('user', ['userInfo'])
  },
  mounted() {
    register({
      name: this.popupName,
      open: ({ afterClose }) => {
        const {
          userInfo: { treasureBox },
          keyName
        } = this
        const hasStorage = window.localStorage.getItem('showGuide') === 'noShow'
        const hasOpen = String(treasureBox).includes(keyName) || hasStorage
        this.afterClose = afterClose

        if (!hasOpen) {
          this.showGuide = true
        } else {
          if (hasStorage) {
            updateTreasureBox({
              keyName: this.keyName
            })
          }
          this.close()
        }
      },
      close: () => {
        this.noGuide()
      }
    })
  },
  methods: {
    noGuide() {
      this.close()
      updateTreasureBox({
        keyName: this.keyName
      })
    },
    close() {
      this.showGuide = false
      if (this.afterClose) {
        this.afterClose()
      }
    }
  }
}
</script>

<style lang="scss">
.message-guide {
  position: fixed;
  top: 0;
  z-index: 999;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  text-align: center;
  padding-top: 130px;
  .icon {
    position: absolute;
    right: 10px;
    top: 5px;
    height: 35px;
    width: 40px;
  }
  .arrow {
    position: absolute;
    right: 35px;
    top: 55px;
    width: 46.81px;
    height: 80.34px;
  }
  .text {
    width: 240px;
    display: block;
    margin: 10px auto 0;
  }
  .button {
    position: absolute;
    bottom: 80px;
    left: 50%;
    transform: translateX(-50%);
    width: 110.47px;
    height: 39.99px;
  }
}
</style>
